import { render, staticRenderFns } from "./TicTacToe.vue?vue&type=template&id=61e2190b&scoped=true&"
import script from "./TicTacToe.vue?vue&type=script&lang=js&"
export * from "./TicTacToe.vue?vue&type=script&lang=js&"
import style0 from "./TicTacToe.vue?vue&type=style&index=0&id=61e2190b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2190b",
  null
  
)

export default component.exports